export default "__VITE_ASSET__Bm30F$T$__"